import React from "react"
import { Grid, IconButton, Link } from "@material-ui/core"

import {
	ArrowForwardIos as GoToConstructionIcon
} from "@material-ui/icons"
import { Kanban as KanbanIcon } from "lucide-react"

import { Portlet } from "@/components"
import { Text } from "letalkui"

import { InboxV2Links } from "@/utils/link"

import useStyles from "@/pages/Admin/Boards/BoardList/BoardItem/styles"

type BoardItemProps = {
	board: {
		id: number
		name: string
	}
}

const BoardItem: React.FC<BoardItemProps> = (props) => {
	const {
		board
	} = props

	const classes = useStyles()

	const boardPath = `${InboxV2Links.boardDetails}/${board.id}`

	return (
		<Portlet
			elevation={1}
		>
			<Grid
				container
				alignItems="center"
				justifyContent="space-between"
			>

				<Grid item xs={1}>
					<KanbanIcon className={classes.kanbanIcon} />
				</Grid>
				<Grid
					item
					xs={10}
				>
					<Grid
						container
						justifyContent="flex-start"
						alignItems="center"
						spacing={3}
					>
						<Grid item>
							<Text.Body
								type="default"
								fontWeight="semibold"
							>
								{board.name}
							</Text.Body>
						</Grid>
					</Grid>
				</Grid>
				<Grid
					item
					xs={1}
				>
					<Grid
						container
						justifyContent={"flex-end"}
					>
						<Grid
							item
						>
							<Link
								href={boardPath}
								target="_blank"
								rel="noreferrer"
							>
								<IconButton
									className={classes.listItemButton}
								>
									<GoToConstructionIcon
										className={classes.icon}
									/>
								</IconButton>
							</Link>
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		</Portlet>
	)
}

export default BoardItem
